<template>
  <button :type="type" :class="buttonClasses" :disabled="isDisabled || isLoading">
    <span class="relative inline-flex items-center justify-center min-w-fit">
      <span
        v-if="isLoading"
        class="absolute animate-spin rounded-full border-2 border-t-transparent border-white"
        :class="{
          'h-4 w-4': size === 'sm',
          'h-5 w-5': size === 'md',
          'h-6 w-6': size === 'lg',
        }"
      >
      </span>

      <span :class="{ invisible: isLoading }">
        <slot />
      </span>
    </span>
  </button>
</template>

<script src="./button.component.ts" lang="ts" />
